import * as React from 'react';
import { Row } from 'react-bootstrap';

import CompanyFeatureFlagsEnum, { CompanyFeatureFlagsTips } from 'ab-enums/companyFeatureFlags.enum';

import ImageTag from 'af-components/Image';
import LockedValue from 'af-components/LockedValue';

import PreviewItem from '../../Shared/PreviewItem';
import SettingPreview from '../../Shared/SettingPreview';

type Props = {
	isSendingInvoiceNotificationsEnabled: boolean;
	emailDomain: Nullable<string>;
	invoiceMessage: string;
	invoiceHeaderImageUrl: Nullable<string>;
	isPlatformAdmin: boolean;
	toggleEdit: () => void;
};

const EnableInvoiceNotificationsPreview: React.FC<Props> = (props) => {
	const {
		isSendingInvoiceNotificationsEnabled,
		emailDomain,
		invoiceMessage,
		invoiceHeaderImageUrl,
		toggleEdit,
		isPlatformAdmin,
	} = props;

	return (
		<SettingPreview toggleEdit={toggleEdit}>
			<div className="company-settings__info-segment">
				<Row className={isPlatformAdmin ? 'row--padded' : ''} >
					<PreviewItem
						checked={!!isSendingInvoiceNotificationsEnabled}
						hint={CompanyFeatureFlagsTips.invoiceNotifications}
						indent={false}
						label={CompanyFeatureFlagsEnum.isSendingInvoiceNotificationsEnabled}
						showCheckbox={true}
					/>
				</Row>
				{
					isPlatformAdmin &&
					<>
						<Row className="row--padded">
							<LockedValue
								label="Email Domain"
								value={
									emailDomain === null
										? <div className="company-settings__empty">There is no selected domain.</div>
										: emailDomain
								}
							/>
						</Row>
						<Row className="row--padded">
							<LockedValue
								label="Invoice Message"
								value={
									invoiceMessage
								}
							/>
						</Row>
						{!!invoiceHeaderImageUrl &&
							<Row className="row--padded">
								<LockedValue
									label="Invoice Header Image"
									renderValue={false}
									value={invoiceHeaderImageUrl}
								/>
								<div className="company-settings__printout-wrapper">
									<ImageTag
										className="company-settings__printout"
										src={invoiceHeaderImageUrl}
									/>
								</div>

							</Row>
						}
					</>
				}
			</div>
		</SettingPreview >
	);
};

export default React.memo(EnableInvoiceNotificationsPreview);
